<template>
  <q-dialog :model-value="companyStore.needsSelection" persistent>
    <q-card style="min-width: 320px; max-width: 420px">
      <q-card-section>
        <div class="text-h6">Select a company</div>
        <div class="text-caption text-grey-7">
          Choose which company you want to create this purchase requisition for.
        </div>
      </q-card-section>

      <q-list separator>
        <q-item
          v-for="company in companyStore.companies"
          :key="company.id"
          clickable
          v-ripple
          @click="companyStore.selectCompany(company.id)"
        >
          <q-item-section>{{ company.name }}</q-item-section>
        </q-item>
      </q-list>
    </q-card>
  </q-dialog>
</template>

<script setup lang="ts">
import { useCompanyStore } from 'src/stores/company';

const companyStore = useCompanyStore();
</script>
